
//

// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import LogrosList from "./LogrosList";
// import IndicadoresList from "./IndicadoresList";
// import { useAuth } from "../context/AuthContext";
// import "../style/Planeacion.css";

// const API_BASE =
//   process.env.REACT_APP_API_PLANEACION || "http://localhost:5001/api/planeacion";

// export default function PlaneacionPage() {
//   const { token, user } = useAuth();
//   const tenantId = user?.tenant_id;
//   const sedeId = user?.sede_id;
//   const profesorId = user?.id;

//   const [grados, setGrados] = useState([]);
//   const [grupos, setGrupos] = useState([]);
//   const [materias, setMaterias] = useState([]);
//   const [periodos, setPeriodos] = useState([]);
//   const [items, setItems] = useState([]);

//   const [filtro, setFiltro] = useState({
//     grado: "",
//     grupo: "",
//     materia_id: "",
//     periodo_id: "",
//     item_id: ""
//   });

//   const [logroActivo, setLogroActivo] = useState(null);

//   const api = useMemo(() => {
//     const instance = axios.create({ baseURL: API_BASE, withCredentials: true });
//     instance.interceptors.request.use(config => {
//       if (token) config.headers.Authorization = `Bearer ${token}`;
//       if (tenantId) config.headers["X-Tenant-ID"] = tenantId;
//       if (sedeId) config.headers["X-Sede-ID"] = sedeId;
//       return config;
//     });
//     return instance;
//   }, [token, tenantId, sedeId]);

//   // Cargar filtros iniciales
//   useEffect(() => {
//     if (!profesorId) return;
//     const cargarFiltros = async () => {
//       try {
//         const { data } = await api.get(`/filtros/${profesorId}`);
//         setGrados(data.grados || []);
//         setPeriodos(data.periodos || []);
//       } catch (err) {
//         console.error("❌ Error cargando filtros:", err);
//       }
//     };
//     cargarFiltros();
//   }, [api, profesorId]);

//   // Cargar grupos cuando cambia grado
//   useEffect(() => {
//     if (!filtro.grado) return setGrupos([]);
//     const cargarGrupos = async () => {
//       try {
//         const { data } = await api.get(`/grupos/${profesorId}/${filtro.grado}`);
//         setGrupos(data || []);
//       } catch (err) {
//         console.error(err);
//         setGrupos([]);
//       }
//     };
//     cargarGrupos();
//     setFiltro(prev => ({ ...prev, grupo: "", materia_id: "", item_id: "" }));
//     setMaterias([]);
//     setItems([]);
//   }, [filtro.grado, api, profesorId]);

//   // Cargar materias cuando cambia grupo
//   useEffect(() => {
//     if (!filtro.grupo || !filtro.grado) return setMaterias([]);
//     const cargarMaterias = async () => {
//       try {
//         const { data } = await api.get(`/materias/${profesorId}/${filtro.grado}/${filtro.grupo}`);
//         setMaterias(data || []);
//       } catch (err) {
//         console.error(err);
//         setMaterias([]);
//       }
//     };
//     cargarMaterias();
//     setFiltro(prev => ({ ...prev, materia_id: "", item_id: "" }));
//     setItems([]);
//   }, [filtro.grupo, filtro.grado, api, profesorId]);

//   // Cargar items cuando cambia materia
//   useEffect(() => {
//     if (!filtro.materia_id) return setItems([]);
//     const cargarItems = async () => {
//       try {
//         const { data } = await api.get(`/items/${filtro.materia_id}`);
//         setItems(data.items || []);
//       } catch (err) {
//         console.error(err);
//         setItems([]);
//       }
//     };
//     cargarItems();
//     setFiltro(prev => ({ ...prev, item_id: "" }));
//   }, [filtro.materia_id, api]);

//   // Manejar cambio de select
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFiltro(prev => ({ ...prev, [name]: value }));
//     setLogroActivo(null); // Limpiar logro activo
//   };

//   return (
//     <div className="planeacion-root">
//       <header className="planeacion-header">
//         <h2>Planeación Académica</h2>
//         <div className="filtros-inline">
//           <select name="grado" value={filtro.grado} onChange={handleChange}>
//             <option value="">Grado</option>
//             {grados.map(g => <option key={g} value={g}>{g}</option>)}
//           </select>
//           <select name="grupo" value={filtro.grupo} onChange={handleChange}>
//             <option value="">Grupo</option>
//             {grupos.map(g => <option key={g} value={g}>{g}</option>)}
//           </select>
//           <select name="materia_id" value={filtro.materia_id} onChange={handleChange}>
//             <option value="">Materia</option>
//             {materias.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}
//           </select>
//           <select name="periodo_id" value={filtro.periodo_id} onChange={handleChange}>
//             <option value="">Periodo</option>
//             {periodos.map(p => (
//               <option key={p.id} value={p.id}>
//                 {p.nombre} {p.activo ? "(Activo)" : ""}
//               </option>
//             ))}
//           </select>
//           <select name="item_id" value={filtro.item_id} onChange={handleChange}>
//             <option value="">Item evaluativo</option>
//             {items.map(it => (
//               <option key={it.item_id} value={it.item_id}>
//                 {it.nombre} ({it.porcentaje}%)
//               </option>
//             ))}
//           </select>
//         </div>
//       </header>

//       <main className="planeacion-threecols">
//         <LogrosList
//           filtro={filtro}
//           onSelectLogro={setLogroActivo}
//           logroActivo={logroActivo}
//         />
//         {logroActivo && <IndicadoresList logroId={logroActivo.id} />}
//       </main>
//     </div>
//   );
// }


//

// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import LogrosList from "./LogrosList";
// import ActividadesList from "./ActividadesList"; // Asegúrate de que el nombre coincida
// import { useAuth } from "../context/AuthContext";
// import "../style/Planeacion.css";

// const API_BASE = "http://localhost:5001/api/planeacion";

// export default function PlaneacionPage() {
//   const { token, user } = useAuth();
//   const profesorId = user?.id;

//   const [grados, setGrados] = useState([]);
//   const [grupos, setGrupos] = useState([]);
//   const [materias, setMaterias] = useState([]);
//   const [periodos, setPeriodos] = useState([]);
//   const [items, setItems] = useState([]);

//   const [filtro, setFiltro] = useState({
//     grado: "",
//     grupo: "",
//     materia_id: "",
//     periodo_id: "",
//     item_id: ""
//   });

//   const [logroActivo, setLogroActivo] = useState(null);

//   const api = useMemo(() => {
//     const instance = axios.create({ baseURL: API_BASE, withCredentials: true });
//     instance.interceptors.request.use(config => {
//       if (token) config.headers.Authorization = `Bearer ${token}`;
//       if (user?.tenant_id) config.headers["X-Tenant-ID"] = user.tenant_id;
//       if (user?.sede_id) config.headers["X-Sede-ID"] = user.sede_id;
//       return config;
//     });
//     return instance;
//   }, [token, user?.tenant_id, user?.sede_id]);

//   // 1. Cargar filtros base (Grados y Periodos)
//   useEffect(() => {
//     if (!profesorId) return;
//     (async () => {
//       try {
//         const { data } = await api.get(`/filtros/${profesorId}`);
//         setGrados(data.grados || []);
//         setPeriodos(data.periodos || []);
//       } catch (err) {
//         console.error("❌ Error inicial:", err);
//       }
//     })();
//   }, [api, profesorId]);

//   // 2. Cargar Grupos por Grado
//   useEffect(() => {
//     if (!filtro.grado) {
//       setGrupos([]);
//       return;
//     }
//     (async () => {
//       try {
//         const { data } = await api.get(`/grupos/${profesorId}/${filtro.grado}`);
//         setGrupos(data || []);
//       } catch (err) { console.error(err); }
//     })();
//   }, [filtro.grado, api, profesorId]);

//   // 3. Cargar Materias por Grupo
//   useEffect(() => {
//     if (!filtro.grupo || !filtro.grado) {
//       setMaterias([]);
//       return;
//     }
//     (async () => {
//       try {
//         const { data } = await api.get(`/materias/${profesorId}/${filtro.grado}/${filtro.grupo}`);
//         setMaterias(data || []);
//       } catch (err) { console.error(err); }
//     })();
//   }, [filtro.grupo, filtro.grado, api, profesorId]);

//   // 4. Cargar Items por Materia
//   useEffect(() => {
//     if (!filtro.materia_id) {
//       setItems([]);
//       return;
//     }
//     (async () => {
//       try {
//         const { data } = await api.get(`/items/${filtro.materia_id}`);
//         setItems(data.items || []);
//       } catch (err) { console.error(err); }
//     })();
//   }, [filtro.materia_id, api]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFiltro(prev => ({ ...prev, [name]: value }));
//     // Resetear selección de logro al cambiar filtros de nivel superior
//     if (["grado", "grupo", "materia_id", "periodo_id"].includes(name)) {
//       setLogroActivo(null);
//     }
//   };

//   return (
//     <div className="planeacion-root">
//       <header className="planeacion-header">
//         <h2>Planeación Académica</h2>
//         <div className="filtros-inline">
//           <select name="grado" value={filtro.grado} onChange={handleChange}>
//             <option value="">Grado</option>
//             {grados.map(g => <option key={g} value={g}>{g}</option>)}
//           </select>

//           <select name="grupo" value={filtro.grupo} onChange={handleChange}>
//             <option value="">Grupo</option>
//             {grupos.map(g => <option key={g} value={g}>{g}</option>)}
//           </select>

//           <select name="materia_id" value={filtro.materia_id} onChange={handleChange}>
//             <option value="">Materia</option>
//             {materias.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}
//           </select>

//           <select name="periodo_id" value={filtro.periodo_id} onChange={handleChange}>
//             <option value="">Periodo</option>
//             {periodos.map(p => (
//               <option key={p.id} value={p.id}>
//                 {p.nombre} {p.activo ? "(Activo)" : ""}
//               </option>
//             ))}
//           </select>

//           <select name="item_id" value={filtro.item_id} onChange={handleChange}>
//             <option value="">Item evaluativo</option>
//             {items.map(it => (
//               <option key={it.item_id} value={it.item_id}>
//                 {it.nombre} ({it.porcentaje}%)
//               </option>
//             ))}
//           </select>
//         </div>
//       </header>

//       <main className="planeacion-threecols">
//         <LogrosList
//           filtro={filtro}
//           onSelectLogro={setLogroActivo}
//           logroActivo={logroActivo}
//         />
        
//         {/* Pasamos el objeto completo 'logro' para evitar el error de validación */}
//         <ActividadesList logro={logroActivo} />
//       </main>
//     </div>
//   );
// }


//

// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import LogrosList from "./LogrosList";
// import ActividadesList from "./ActividadesList";
// import { useAuth } from "../context/AuthContext";
// import "../style/Planeacion.css";

// const API_BASE = "http://3.236.217.225:5001/api/planeacion";

// export default function PlaneacionPage() {
//   const { token, user } = useAuth();
//   const profesorId = user?.id;

//   const [grados, setGrados] = useState([]);
//   const [grupos, setGrupos] = useState([]);
//   const [materias, setMaterias] = useState([]);
//   const [periodos, setPeriodos] = useState([]);
//   const [items, setItems] = useState([]);
//   const [filtro, setFiltro] = useState({ grado: "", grupo: "", materia_id: "", periodo_id: "", item_id: "" });
  
//   const [logroActivo, setLogroActivo] = useState(null);
//   const [refreshKey, setRefreshKey] = useState(0); // Para forzar recarga de actividades

//   const api = useMemo(() => {
//     const instance = axios.create({ baseURL: API_BASE, withCredentials: true });
//     instance.interceptors.request.use(config => {
//       if (token) config.headers.Authorization = `Bearer ${token}`;
//       if (user?.tenant_id) config.headers["X-Tenant-ID"] = user.tenant_id;
//       if (user?.sede_id) config.headers["X-Sede-ID"] = user.sede_id;
//       return config;
//     });
//     return instance;
//   }, [token, user]);

//   useEffect(() => {
//     if (!profesorId) return;
//     (async () => {
//       try {
//         const { data } = await api.get(`/filtros/${profesorId}`);
//         setGrados(data.grados || []);
//         setPeriodos(data.periodos || []);
//       } catch (err) { console.error("Error inicial:", err); }
//     })();
//   }, [api, profesorId]);

//   /* Efectos de carga de filtros (Grado -> Grupo -> Materia -> Item) ... (Mantener igual que tu código) */
//   useEffect(() => { /* Cargar Grupos */ if (filtro.grado) api.get(`/grupos/${profesorId}/${filtro.grado}`).then(r => setGrupos(r.data)); }, [filtro.grado, api, profesorId]);
//   useEffect(() => { /* Cargar Materias */ if (filtro.grupo) api.get(`/materias/${profesorId}/${filtro.grado}/${filtro.grupo}`).then(r => setMaterias(r.data)); }, [filtro.grupo, filtro.grado, api, profesorId]);
//   useEffect(() => { /* Cargar Items */ if (filtro.materia_id) api.get(`/items/${filtro.materia_id}`).then(r => setItems(r.data.items)); }, [filtro.materia_id, api]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFiltro(prev => ({ ...prev, [name]: value }));
//     if (["grado", "grupo", "materia_id", "periodo_id"].includes(name)) setLogroActivo(null);
//   };

//   // Esta función se pasa a LogrosList
//   const handleLogroFinalizado = (logro) => {
//     setLogroActivo(logro);
//     setRefreshKey(prev => prev + 1); // Notifica a ActividadesList que debe recargar
//   };

//   return (
//     <div className="planeacion-root">
//       <header className="planeacion-header">
//         <h2>Planeación Académica</h2>
//         <div className="filtros-inline">
//             <select name="grado" value={filtro.grado} onChange={handleChange}><option value="">Grado</option>{grados.map(g => <option key={g} value={g}>{g}</option>)}</select>
//             <select name="grupo" value={filtro.grupo} onChange={handleChange}><option value="">Grupo</option>{grupos.map(g => <option key={g} value={g}>{g}</option>)}</select>
//             <select name="materia_id" value={filtro.materia_id} onChange={handleChange}><option value="">Materia</option>{materias.map(m => <option key={m.id} value={m.id}>{m.nombre}</option>)}</select>
//             <select name="periodo_id" value={filtro.periodo_id} onChange={handleChange}><option value="">Periodo</option>{periodos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}</select>
//             <select name="item_id" value={filtro.item_id} onChange={handleChange}><option value="">Item</option>{items.map(it => <option key={it.item_id} value={it.item_id}>{it.nombre}</option>)}</select>
//         </div>
//       </header>

//       <main className="planeacion-threecols">
//         <LogrosList
//           filtro={filtro}
//           onSelectLogro={handleLogroFinalizado}
//           logroActivo={logroActivo}
//         />
//         <ActividadesList 
//           logro={logroActivo} 
//           key={refreshKey} // Al cambiar la key, el componente se destruye y se vuelve a crear (re-ejecuta el GET)
//         />
//       </main>
//     </div>
//   );
// }

//
import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import LogrosList from "./LogrosList";
import ActividadesList from "./ActividadesList";
import { useAuth } from "../context/AuthContext";
import { API } from "../components/config";
import "../style/Planeacion.css";

const API_BASE = `${API}/planeacion`;

export default function PlaneacionPage() {
  const { token, user } = useAuth();
  const profesorId = user?.id;

  const [grados, setGrados] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [materias, setMaterias] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [items, setItems] = useState([]);

  const [filtro, setFiltro] = useState({
    grado: "",
    grupo: "",
    materia_id: "",
    periodo_id: "",
    item_id: ""
  });

  const [logroActivo, setLogroActivo] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const api = useMemo(() => {
    const instance = axios.create({ baseURL: API_BASE });

    instance.interceptors.request.use((config) => {
      if (token) config.headers.Authorization = `Bearer ${token}`;
      config.headers["X-Tenant-ID"] = user?.tenant_id;
      config.headers["X-Sede-ID"] = user?.sede_id;
      return config;
    });

    return instance;
  }, [token, user]);

  useEffect(() => {
    if (!profesorId) return;

    api.get(`/filtros/${profesorId}`)
      .then(r => {
        setGrados(r.data?.grados || []);
        setPeriodos(r.data?.periodos || []);
      })
      .catch(console.error);
  }, [api, profesorId]);

  useEffect(() => {
    if (!filtro.grado) return setGrupos([]);

    api.get(`/grupos/${profesorId}/${filtro.grado}`)
      .then(r => setGrupos(r.data || []));
  }, [filtro.grado]);

  useEffect(() => {
    if (!filtro.grupo) return setMaterias([]);

    api.get(`/materias/${profesorId}/${filtro.grado}/${filtro.grupo}`)
      .then(r => setMaterias(r.data || []));
  }, [filtro.grupo]);

  useEffect(() => {
    if (!filtro.materia_id) return setItems([]);

    api.get(`/items/${filtro.materia_id}`)
      .then(r => setItems(r.data?.items || []));
  }, [filtro.materia_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFiltro((prev) => {
      const f = { ...prev, [name]: value };

      if (name === "grado") f.grupo = f.materia_id = f.item_id = "";
      if (name === "grupo") f.materia_id = f.item_id = "";
      if (name === "materia_id") f.item_id = "";

      return f;
    });

    if (["grado", "grupo", "materia_id"].includes(name)) {
      setLogroActivo(null);
    }
  };

  return (
    <div className="planeacion-root">
      <header>
        <h2>📅 Planeación</h2>

        <div className="filtros-inline">
          <select name="grado" value={filtro.grado} onChange={handleChange}>
            <option value="">Grado</option>
            {grados.map((g) => <option key={g}>{g}</option>)}
          </select>

          <select name="grupo" value={filtro.grupo} onChange={handleChange}>
            <option value="">Grupo</option>
            {grupos.map((g) => <option key={g}>{g}</option>)}
          </select>

          <select name="materia_id" value={filtro.materia_id} onChange={handleChange}>
            <option value="">Materia</option>
            {materias.map((m) => (
              <option key={m.id} value={m.id}>
                {m.nombre}
              </option>
            ))}
          </select>

          <select name="periodo_id" value={filtro.periodo_id} onChange={handleChange}>
            <option value="">Periodo</option>
            {periodos.map((p) => (
              <option key={p.id} value={p.id}>
                {p.nombre}
              </option>
            ))}
          </select>

          <select name="item_id" value={filtro.item_id} onChange={handleChange}>
            <option value="">Item</option>
            {items.map((i) => (
              <option key={i.item_id} value={i.item_id}>
                {i.nombre}
              </option>
            ))}
          </select>
        </div>
      </header>

      <main>
        <LogrosList
          filtro={filtro}
          logroActivo={logroActivo}
          onSelectLogro={(l) => {
            setLogroActivo(l);
            setRefreshKey((p) => p + 1);
          }}
        />

        <ActividadesList
          logro={logroActivo}
          key={`${logroActivo?.id}-${refreshKey}`}
        />
      </main>
    </div>
  );
}
